"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paginacao = void 0;
var react_1 = __importStar(require("react"));
var Botao_1 = require("../Botao/Botao");
var Icone_1 = require("../Icone/Icone");
var Cores_1 = require("../Cores/Cores");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var estiloPaginacao = require("./Paginacao.module.scss");
var Paginacao = function (_a) {
    var totalItens = _a.totalItens, itensPorPagina = _a.itensPorPagina, _b = _a.paginaAtual, paginaAtual = _b === void 0 ? 1 : _b, _c = _a.config, config = _c === void 0 ? {
        permitirSelecaoItensPorPagina: true,
    } : _c, _d = _a.opcoesItensPorPagina, opcoesItensPorPagina = _d === void 0 ? [10, 25, 50, 100] : _d, onPageChange = _a.onPageChange, onItensPorPaginaChange = _a.onItensPorPaginaChange;
    var _e = (0, react_1.useState)(paginaAtual), paginaAtiva = _e[0], setPaginaAtiva = _e[1];
    var _f = (0, react_1.useState)(false), dropdownAberto = _f[0], setDropdownAberto = _f[1];
    var _g = (0, react_1.useState)(itensPorPagina), itensPorPaginaState = _g[0], setItensPorPaginaState = _g[1];
    var _h = (0, react_1.useState)("baixo"), dropdownDirecao = _h[0], setDropdownDirecao = _h[1];
    var dropdownRef = (0, react_1.useRef)(null);
    var totalPaginas = Math.ceil(totalItens / itensPorPaginaState);
    var maximoPosicoesArray = 7;
    var handlePageClick = function (page) {
        setPaginaAtiva(page);
        if (onPageChange) {
            onPageChange(page);
        }
    };
    var handleItensPorPaginaChange = function (novoItensPorPagina) {
        setItensPorPaginaState(novoItensPorPagina);
        if (onItensPorPaginaChange) {
            onItensPorPaginaChange(novoItensPorPagina);
        }
        setDropdownAberto(false);
        setPaginaAtiva(1);
        if (onPageChange) {
            onPageChange(1);
        }
    };
    var toggleDropdown = function () {
        if (!dropdownAberto) {
            // Verificar espaço disponível antes de abrir o dropdown
            verificarEspacoDropdown();
        }
        setDropdownAberto(!dropdownAberto);
    };
    var verificarEspacoDropdown = function () {
        if (dropdownRef.current) {
            var rect = dropdownRef.current.getBoundingClientRect();
            var alturaDropdown = Math.max(opcoesItensPorPagina.length * 40 + 20, 120);
            var espacoAbaixo = window.innerHeight - rect.bottom - 20;
            var espacoAcima = rect.top - 20;
            console.log("Verificando espaço:", {
                alturaDropdown: alturaDropdown,
                espacoAbaixo: espacoAbaixo,
                espacoAcima: espacoAcima,
                windowHeight: window.innerHeight,
                rectBottom: rect.bottom,
                rectTop: rect.top,
            });
            if (espacoAbaixo < alturaDropdown &&
                espacoAcima >= alturaDropdown) {
                console.log("Abrindo para cima");
                setDropdownDirecao("cima");
            }
            else {
                console.log("Abrindo para baixo");
                setDropdownDirecao("baixo");
            }
        }
    };
    var paginacaoAte6paginas = function () {
        var paginas = [];
        var _loop_1 = function (i) {
            paginas.push(react_1.default.createElement("li", { key: i },
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: false, estilo: i === paginaAtiva ? "primaryLight" : "outlined", tamanho: "small", tipo: "tipoDefault", style: { padding: "0 2px" }, onClick: function () { return handlePageClick(i); } },
                    react_1.default.createElement("div", { className: estiloPaginacao.pagina },
                        react_1.default.createElement(Corpo_1.Corpo, { tipo: "button2", negrito: 700, cor: i === paginaAtiva
                                ? Cores_1.Cores.GradacaoNeutros.BrancoMU50
                                : Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }, i)))));
        };
        for (var i = 1; i <= totalPaginas; i++) {
            _loop_1(i);
        }
        return paginas;
    };
    var paginacaoAcima6paginas = function () {
        var paginas = [];
        if (paginaAtiva > 1) {
            var numeroPagina_1 = 1;
            paginas.push(react_1.default.createElement("li", null,
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: numeroPagina_1 === paginaAtiva
                        ? "primaryLight"
                        : "outlined", tamanho: "xsmall", tipo: "tipoIconSquare", onClick: function () { return handlePageClick(numeroPagina_1); } },
                    react_1.default.createElement("div", { className: estiloPaginacao.pagina }, numeroPagina_1))));
        }
        if (paginaAtiva > 3) {
            paginas.push(react_1.default.createElement("li", null,
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "ghost", tamanho: "xsmall" },
                    react_1.default.createElement("div", { className: estiloPaginacao.pagina }, "..."))));
        }
        if (paginaAtiva == totalPaginas) {
            paginas.push(react_1.default.createElement("li", null,
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "outlined", tamanho: "xsmall", tipo: "tipoIconSquare", onClick: function () { return handlePageClick(paginaAtiva - 2); } },
                    react_1.default.createElement("div", { className: estiloPaginacao.pagina }, paginaAtiva - 2))));
        }
        if (paginaAtiva >= 3) {
            paginas.push(react_1.default.createElement("li", null,
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "outlined", tamanho: "xsmall", tipo: "tipoIconSquare", onClick: function () { return handlePageClick(paginaAtiva - 1); } },
                    react_1.default.createElement("div", { className: estiloPaginacao.pagina }, paginaAtiva - 1))));
        }
        /* PAGINA ATUAL */
        paginas.push(react_1.default.createElement("li", null,
            react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "primaryLight", tamanho: "xsmall", tipo: "tipoIconSquare", onClick: function () { return handlePageClick(paginaAtiva); } },
                react_1.default.createElement("div", { className: estiloPaginacao.pagina }, paginaAtiva))));
        if (paginaAtiva + 2 <= totalPaginas) {
            paginas.push(react_1.default.createElement("li", null,
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "outlined", tamanho: "xsmall", tipo: "tipoIconSquare", onClick: function () { return handlePageClick(paginaAtiva + 1); } },
                    react_1.default.createElement("div", { className: estiloPaginacao.pagina }, paginaAtiva + 1))));
        }
        if (paginaAtiva == 1 && paginaAtiva + 2 < totalPaginas) {
            paginas.push(react_1.default.createElement("li", null,
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "outlined", tamanho: "xsmall", tipo: "tipoIconSquare", onClick: function () { return handlePageClick(3); } },
                    react_1.default.createElement("div", { className: estiloPaginacao.pagina }, 3))));
        }
        if (paginaAtiva + 2 < totalPaginas) {
            paginas.push(react_1.default.createElement("li", null,
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "ghost", tamanho: "xsmall" },
                    react_1.default.createElement("div", { className: estiloPaginacao.pagina }, "..."))));
        }
        if (paginaAtiva != totalPaginas) {
            paginas.push(react_1.default.createElement("li", null,
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "outlined", tamanho: "xsmall", tipo: "tipoIconSquare", onClick: function () { return handlePageClick(totalPaginas); } },
                    react_1.default.createElement("div", { className: estiloPaginacao.pagina }, totalPaginas))));
        }
        return paginas;
    };
    var getPaginasVisiveis = function () {
        if (totalPaginas < maximoPosicoesArray) {
            return paginacaoAte6paginas();
        }
        else {
            return paginacaoAcima6paginas();
        }
    };
    (0, react_1.useEffect)(function () {
        function handleClickOutside(event) {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target)) {
                setDropdownAberto(false);
            }
        }
        if (dropdownAberto) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownAberto]);
    (0, react_1.useEffect)(function () {
        setPaginaAtiva(paginaAtual < 1 ? 1 : paginaAtual);
    }, [paginaAtual]);
    (0, react_1.useEffect)(function () {
        setItensPorPaginaState(itensPorPagina);
    }, [itensPorPagina]);
    return (react_1.default.createElement("div", { className: estiloPaginacao.divPrincipal, ref: dropdownRef },
        config.permitirSelecaoItensPorPagina && (react_1.default.createElement("label", { className: estiloPaginacao.labelDropdown, style: { position: "relative" } },
            react_1.default.createElement("span", { className: estiloPaginacao.labelDropdownSpan },
                "Itens por p\u00E1gina:",
                " "),
            react_1.default.createElement("div", { className: estiloPaginacao.labelDropdownButton, onClick: toggleDropdown },
                itensPorPaginaState,
                " ",
                react_1.default.createElement(Icone_1.Icone, { nome: "expand_more", className: "".concat(dropdownAberto
                        ? estiloPaginacao.dropDownIcon
                        : "") })),
            dropdownAberto && (react_1.default.createElement("ul", { className: estiloPaginacao.dropdownMenu, style: __assign({ position: "absolute", left: 0, zIndex: 1000, backgroundColor: "white", border: "1px solid #ccc", borderRadius: "4px", maxHeight: "200px", overflowY: "auto", minWidth: "60px", justifySelf: "center", right: -100 }, (dropdownDirecao === "cima"
                    ? {
                        bottom: "100%",
                        top: "auto",
                        boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
                    }
                    : {
                        top: "100%",
                        bottom: "auto",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    })) }, opcoesItensPorPagina.map(function (opcao) { return (react_1.default.createElement("li", { key: opcao, className: estiloPaginacao.dropdownItem, onClick: function () {
                    return handleItensPorPaginaChange(opcao);
                } }, opcao)); }))),
            react_1.default.createElement("span", { className: "".concat(estiloPaginacao.labelDropdownSpan, " ").concat(estiloPaginacao.labelDropdownSpanItens) }, "".concat((paginaAtiva - 1) * itensPorPaginaState + 1, "-").concat(Math.min(paginaAtiva * itensPorPaginaState, totalItens), " de ").concat(totalItens, " itens")))),
        react_1.default.createElement("div", { className: estiloPaginacao.divPaginacao },
            react_1.default.createElement("div", { className: estiloPaginacao.divBotoes },
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "outlined", tamanho: "xsmall", onClick: function () { return handlePageClick(1); } },
                    react_1.default.createElement(Icone_1.Icone, { nome: "keyboard_double_arrow_left", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, largura: "30px" })),
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "outlined", tamanho: "xsmall", onClick: function () {
                        return handlePageClick(Math.max(1, paginaAtiva - 1));
                    } },
                    react_1.default.createElement(Icone_1.Icone, { nome: "chevron_left", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, largura: "30px" }))),
            react_1.default.createElement("div", { className: estiloPaginacao.divUl },
                react_1.default.createElement("ul", null, getPaginasVisiveis())),
            react_1.default.createElement("div", { className: estiloPaginacao.divBotoes },
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "outlined", tamanho: "xsmall", onClick: function () {
                        return handlePageClick(Math.min(totalPaginas, paginaAtiva + 1));
                    } },
                    react_1.default.createElement(Icone_1.Icone, { nome: "chevron_right", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, largura: "30px" })),
                react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, estilo: "outlined", tamanho: "xsmall", onClick: function () { return handlePageClick(totalPaginas); } },
                    react_1.default.createElement(Icone_1.Icone, { nome: "keyboard_double_arrow_right", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, largura: "30px" }))))));
};
exports.Paginacao = Paginacao;
